/* eslint-disable no-undef */
/* eslint-disable no-sequences */
/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
$(() => { const t = $('a[data-attribute*="back-to-top"]'); $(window).on('scroll', function () { t.toggleClass('back-to-top-show', t.length && $(this).scrollTop() >= 100); }), t.on('click', () => { $('body,html').animate({ scrollTop: 0 }, 800); }); });
